import { call, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILURE,
  CREATE_GROUP_REQUEST,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_FAILURE,
  fetchGroupsSuccess,
  fetchGroupsFailure,
  createGroupSuccess,
  createGroupFailure
} from '../actions/groupActions';

// Fetch Groups Saga
function* fetchGroups() {
  try {
    const response = yield call(axios.get, '/sampleGroupData.json');
    yield put(fetchGroupsSuccess(response.data));
  } catch (error) {
    yield put(fetchGroupsFailure(error.message));
  }
}

// Create Group Saga
function* createGroup(action) {
  try {
    // Simulating an API call to create a group
    // You might use `axios.post` to send data to your API
    const response = yield call(axios.post, '/api/groups', action.payload);
    yield put(createGroupSuccess(response.data));
  } catch (error) {
    yield put(createGroupFailure(error.message));
  }
}

// Watcher Saga
function* groupSagas() {
  yield takeEvery(FETCH_GROUPS_REQUEST, fetchGroups);
  yield takeEvery(CREATE_GROUP_REQUEST, createGroup);
}

export default groupSagas;
